import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "p-m-4" }
const _hoisted_3 = { class: "kn-material-input-label" }
const _hoisted_4 = { class: "p-m-4" }
const _hoisted_5 = { class: "kn-material-input-label" }
const _hoisted_6 = { class: "p-m-4" }
const _hoisted_7 = { class: "kn-material-input-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_Dialog, {
      header: _ctx.$t('workspace.federationDefinition.savingFederation'),
      style: _ctx.workspaceFederationSaveDialogDescriptor.dialog.style,
      visible: _ctx.visible,
      modal: true,
      class: "p-fluid kn-dialog--toolbar--primary",
      closable: false
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          class: "kn-button kn-button--primary",
          onClick: _ctx.closeDialog
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.close')), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_Button, {
          class: "kn-button kn-button--primary",
          disabled: _ctx.saveButtonDisabled,
          onClick: _ctx.saveFederation
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ]),
      default: _withCtx(() => [
        (_ctx.dataset)
          ? (_openBlock(), _createBlock("div", _hoisted_1, [
              _createVNode("div", _hoisted_2, [
                _createVNode("span", null, [
                  _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('common.label')) + " *", 1),
                  _createVNode(_component_InputText, {
                    class: ["kn-material-input p-inputtext-sm", {
                                'p-invalid': _ctx.labelDirty && (!_ctx.dataset.label || _ctx.dataset.label.length === 0)
                            }],
                    modelValue: _ctx.dataset.label,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.dataset.label = $event)),
                    onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.labelDirty = true)),
                    onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.labelDirty = true))
                  }, null, 8, ["modelValue", "class"])
                ]),
                _withDirectives(_createVNode("div", { class: "p-error p-my-2" }, _toDisplayString(_ctx.$t('common.validation.required', { fieldName: _ctx.$t('common.label') })), 513), [
                  [_vShow, _ctx.labelDirty && (!_ctx.dataset.label || _ctx.dataset.label.length === 0)]
                ])
              ]),
              _createVNode("div", _hoisted_4, [
                _createVNode("span", null, [
                  _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('common.name')) + " *", 1),
                  _createVNode(_component_InputText, {
                    class: ["kn-material-input p-inputtext-sm", {
                                'p-invalid': _ctx.nameDirty && (!_ctx.dataset.name || _ctx.dataset.name.length === 0)
                            }],
                    modelValue: _ctx.dataset.name,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.dataset.name = $event)),
                    onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.nameDirty = true)),
                    onBlur: _cache[6] || (_cache[6] = ($event: any) => (_ctx.nameDirty = true))
                  }, null, 8, ["modelValue", "class"])
                ]),
                _withDirectives(_createVNode("div", { class: "p-error p-my-2" }, _toDisplayString(_ctx.$t('common.validation.required', { fieldName: _ctx.$t('common.name') })), 513), [
                  [_vShow, _ctx.nameDirty && (!_ctx.dataset.name || _ctx.dataset.name.length === 0)]
                ])
              ]),
              _createVNode("div", _hoisted_6, [
                _createVNode("span", null, [
                  _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('common.description')), 1),
                  _createVNode(_component_InputText, {
                    class: "kn-material-input p-inputtext-sm",
                    modelValue: _ctx.dataset.description,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.dataset.description = $event))
                  }, null, 8, ["modelValue"])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["header", "style", "visible"])
  ]))
}